<template>
    <div>
        
        <PageTitle v-bind:title="title" v-bind:admin="false" />


        <div v-if="id==1">
            <div>
                <img src="/images/articles/56329668-2805-4B1D-8606-C6A729A4CE3E.jpeg" alt="">
            </div>
            <div class="mt-4">
                <p>Управление по санитарному надзору за качеством пищевых продуктов и медикаментов США (FDA) одобрило сетмеланотид (Imcivree, Rhythm Pharmaceuticals) – средство для контроля веса у взрослых и детей в возрасте от 6 лет с ожирением, обусловленного дефицитом проопиомеланокортина, пропротеиновой конвертазы субтилизин-кексин типа 1 или рецептора лептина. Лица с этими редкими генетическими причинами тяжелого ожирения имеют при рождении нормальную массу тела, но в течение нескольких месяцев у них развивается стойкое тяжелое ожирение вследствие непреодолимого голода (гиперфагии).</p>
                <p>Сетмеланотид, агонист рецептора меланокортина-4 (MC4R), является первым одобренным FDAпрепаратом для лечения этих заболеваний. Препарат оценивался в двух клинических исследованиях 3-й фазы. В первом из них 80% пациентов с ожирением вследствие дефицита проопиомеланокортина либо пропротеиновой конвертазы субтилизин-кексин типа 1 достигли потери веса более 10% после 1 года лечения. Во втором исследовании аналогичного результата достигли 45,5% пациентов с ожирением вследствие дефицита рецептора лептина.</p>
                <p>Сетмеланотид в целом хорошо переносился в обоих исследованиях. Наиболее частыми побочными эффектами были реакции в месте инъекции, гиперпигментация кожи и тошнота.</p>
                <p>Ожидается, что препарат появится в продаже в США в первом квартале 2021 года.</p>
                <p class="font-italic">Буеверов Алексей Олегович, д.м.н., профессор Первого МГМУ им. И.М. Сеченова, ведущий научный сотрудник МОНИКИ им. М.Ф. Владимирского, президент Фонда «Доказательная медицина»</p>
            </div>
        </div>

        <div v-if="id==2">
            <div>
                <img src="/images/articles/1DB92691-EBED-4B58-B31D-095A8608D578.jpeg" alt="">
            </div>
            <div class="mt-4">
                <p class="font-italic">Предпосылки и цели</p>
                <p>Общенациональное ретроспективное исследование проведено с целью выяснения частоты и причин лекарственных поражений печени (ЛПП) в континентальном Китае.</p>
                <p class="font-italic">Методы</p>
                <p>Аккумулированы данные о 25 927 подтвержденных случаях ЛПП, госпитализированных с 2012 по 2014 год в 308 медицинских центрах. Проанализированы демографические, анамнестические и лабораторные данные, лекарственный анамнез, данные о тяжести заболевания и смертности от всех пациентов. Исследователей в каждом медицинском учреждении просили оценить причинно-следственную связь для каждого случая с диагнозом ЛПП (n = 29 478).</p>
                <p class="font-italic">Полученные результаты</p>
                <p>Большинство случаев ЛПП были представлены гепатоцеллюлярным поражением (51,39%; 95%-ный ДИ 50,76–52,03), за которым следовали смешанные (28,30%; 95%-ный ДИ 27,73–28,87) и холестатические поражения (20,31%; 95% ДИ 19,80–20,82). Ведущими классами этиологических препаратов были традиционные китайские лекарства или растительные и диетические добавки (26,81%) и противотуберкулезные препараты (21,99%). Хронические ЛПП наблюдались в 13% случаев. В 280 случаев (1,08%) развилась печеночная недостаточность, из них 102 пациента умерли (0,39%); в 2 случаях выполнена трансплантация печени (0,01%). Следует отметить, что в данный анализ включены только госпитализированные пациенты, поэтому истинная частота ЛПП, по всей видимости, окажется выше.</p>
                <p class="font-italic">Выводы</p>
                <p>Заболеваемость ЛПП в континентальном Китае составляет 23,8 на 100 000 человек; этот показатель превышает таковой в западных странах. Основные причины ЛПП – традиционные китайские средства, растительные и диетические добавки, а также противотуберкулезные препараты.</p>
                <p class="font-italic">Буеверов Алексей Олегович, д.м.н., профессор Первого МГМУ им. И.М. Сеченова, ведущий научный сотрудник МОНИКИ им. М.Ф. Владимирского, президент Фонда «Доказательная медицина»</p>
            </div>
        </div>



    </div>
</template>
<script>
import PageTitle from '@/components/PageTitle'
export default {
    data() {
        return {
            title: '',
            id : 0,
        }
    },
    async mounted() {
        this.id = this.$route.params.id
        if ((this.id != 1) && (this.id != 2)) {
            this.$router.push({ path: '404' })
        }
        if (this.id == 1) {
            this.title = "FDA одобрило первый препарат для лечения генетически детерминированного ожирения"
        }
        if (this.id == 2) {
            this.title = "Заболеваемость и этиология лекарственных поражений печени в континентальном Китае"
        }

    },
    methods: {
    },
    components: {

        PageTitle,
        
    }
}
</script>